import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('yawana-purchase')) {
  customElements.define('yawana-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.add(event));
      this.setUpSticky();
      this.update();
    }

    update() {
      const selected = this.querySelector('input[name="id"]:checked');
      const button = this.form.querySelector('button[type="submit"]');
      if (!selected) { button.disabled = true; return; }
      const { count, money, plan, recurringMoney, saving } = selected.dataset;
      const checkbox = this.querySelector('[data-refill]');
      const available = Boolean(plan);
      this.querySelector('.yw-refill').hidden = !available;
      this.querySelector('[data-single-note]').hidden = available;
      if (!available) checkbox.checked = false;
      const recurring = available && checkbox.checked;
      const planInput = this.querySelector('[name="selling_plan"]');
      planInput.disabled = !recurring;
      planInput.value = recurring ? plan : '';
      this.querySelector('[data-refill-title]').textContent = `Subscribe & Save ${saving} on every delivery`;
      this.querySelector('[data-refill-detail]').textContent = `Get ${count} pouches every ${count} months for ${recurringMoney} with free US shipping.`;
      const price = recurring ? recurringMoney : money;
      button.disabled = false;
      button.textContent = `${recurring ? 'SUBSCRIBE' : 'ADD TO CART'} — ${price}`;
      this.querySelector('[data-terms]').textContent = recurring
        ? `${price} charged today, then every ${count} months until canceled. Free US shipping. Applicable taxes calculated at checkout.`
        : `One-time purchase. ${count === '1' ? '$5.95 US shipping.' : 'Free US shipping.'} Applicable taxes calculated at checkout.`;
      const stickyButton = this.querySelector('[data-sticky-button]');
      if (stickyButton) {
        stickyButton.textContent = button.textContent;
        this.querySelector('[data-sticky-total]').textContent = `${count} ${count === '1' ? 'pouch' : 'pouches'}${recurring ? ' · Subscribe & Save' : ''}`;
      }
    }

    // Adds through the AJAX cart so Horizon's cart drawer opens instead of the /cart page.
    async add(event) {
      event.preventDefault();
      const button = this.form.querySelector('button[type="submit"]');
      const error = this.querySelector('[data-error]');
      const formData = new FormData(this.form);
      const deferred = CartLinesUpdateEvent.createPromise();
      error.hidden = true;
      button.disabled = true;
      this.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
        promise: deferred.promise,
      }));
      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || result.status) throw new Error(result.description || 'We couldn’t add that to your cart.');
        const cart = await (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
        this.dispatchEvent(new CustomEvent('yawana:added', { bubbles: true }));
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'yawana-purchase', itemCount: 1, didError: false },
        });
      } catch (failure) {
        error.textContent = `${failure.message.replace(/[.!]?$/, '.')} Your selection is still here; please try again.`;
        error.hidden = false;
        const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json()).catch(() => null);
        deferred.resolve({
          cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : undefined,
          detail: { items: cart?.items ?? [], source: 'yawana-purchase', itemCount: cart?.item_count ?? 0, didError: true },
        });
      } finally {
        button.disabled = false;
      }
    }

    // Phone-only bar, shown whenever the main button is off screen.
    setUpSticky() {
      const bar = this.querySelector('[data-sticky]');
      if (!bar) return;
      const button = this.form.querySelector('button[type="submit"]');
      bar.querySelector('[data-sticky-button]').addEventListener('click', () => this.form.requestSubmit());
      new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting;
      }).observe(button);
    }
  });
}
